import { callMoodleWS } from "./duel";

/**
 * Returns the current user's aggregate and per-quiz gamble statistics.
 */
export const getUserDoubtStats = async ({ token }) =>
  callMoodleWS({
    token,
    wsfunction: "local_tipddy_pregunta_dudosa_get_user_doubt_stats",
  });

/**
 * Returns the current user's saved quiz-question metadata.
 */
export const getUserSavedQuestions = async ({ token }) =>
  callMoodleWS({
    token,
    wsfunction: "local_tipddy_pregunta_dudosa_get_user_saved_questions",
  });

/**
 * Saves or removes a question from the current user's study list.
 */
export const toggleSavedQuestion = async ({ token, questionId, quizId, cmid, saved }) =>
  callMoodleWS({
    token,
    wsfunction: "local_tipddy_pregunta_dudosa_toggle_saved_question",
    params: {
      question_id: questionId,
      quiz_id: quizId,
      cmid,
      saved: saved ? 1 : 0,
    },
  });
